module.exports = __webpack_public_path__ + "img/huanzhe2.1e1b37b1.png";